import { useContext } from "react";
import { ModalsContext } from "../../components/providers/Modals-provider/ModalsContext";
import { IUseModals } from "../../store/types/modals";

export const useModals = (): IUseModals => useContext(ModalsContext);
